import { ServiceController } from './service-controller.urls';

export class ServiceActions {
	public static GET_GAME_GROUPS = `${ServiceController.LOBBY_CONTROLLER}getgamegroups`;
	public static GET_CATEGORIES = `${ServiceController.LOBBY_CONTROLLER}getcategories`;

	public static GET_GAME_SESSION = `${ServiceController.PLAYER_CONTROLLER}startgamesession`;
}
